import { useNavigate } from 'react-router-dom';

const useRedirectToThankYouPage = (profile, isLastPoint, verificationConfiguration) => {
    const navigate = useNavigate();

    const isDocumentVerified =
        !profile.loading && profile?.verification_details?.is_document_verified === 1;
    const isKbaVerified = !profile.loading && profile?.verification_details?.is_kba_verified === 1;
    const isBankVerified = !profile.loading && profile?.verification_details?.is_bank_owner_matched;

    if (verificationConfiguration === 'AND') {
        if (isDocumentVerified && isKbaVerified && isBankVerified && isLastPoint) {
            navigate('/thank-you');
        }
    } else if ((isDocumentVerified || isKbaVerified || isBankVerified) && isLastPoint) {
        navigate('/thank-you');
    }
};

export default useRedirectToThankYouPage;
